import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const setPublishedDate = api(async function setPublishedDate({ projectId, publishDate }) {
    return mutate(
        gql`
            mutation SetPublishedDate($projectId: String!, $publishDate: String!) {
                setPublishedDate(projectId: $projectId, publishDate: $publishDate) {
                    success
                    error
                    warnings
                }
            }
        `,
        { projectId, publishDate },
        { returns: "setPublishedDate" }
    )
})
